module.exports = __webpack_public_path__ + "static/cady-e0055c80d5d8a71d2da49200544db93c.jpg";